

const { format } = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
})


export function brazilianDateFormat(date) {
    try {
        return format(new Date(date))
    } catch (error) {
        return date
    }
}
